<template>
	<div>
		<div class="title">{{title}}</div>
		<el-divider v-if="isdivider"></el-divider>
	</div>
</template>

<script>
	export default {
		props:['title','isdivider'],//接收
		data() {
			return {}
		},
	}
</script>

<style lang="less" scoped>
	.el-divider--horizontal{
		margin: 12px 0px;
	}
</style>
